module.exports = __webpack_public_path__ + "img/header_dsk@2x.42e43d1.webp";